import React from 'react';
import { Box, Typography } from '@mui/material';
import FieldLabel from './FieldLabel';

function MetricItem({ label, value, positive }) {
    const color =
        positive === undefined ? 'text.primary' : positive ? 'success.main' : 'error.main';
    return (
        <Box sx={{ flex: '1 1 70px', minWidth: 64 }}>
            <FieldLabel label={label} />
            <Typography variant="body2" fontWeight={600} color={color} sx={{ lineHeight: 1.3 }}>
                {value}
            </Typography>
        </Box>
    );
}

export default function MetricStrip({ metrics }) {
    if (!metrics) return null;

    const netPnl = metrics.net_pnl ?? 0;

    return (
        <Box
            sx={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: 1,
                mt: 1.5,
                pt: 1.5,
                borderTop: '1px solid',
                borderColor: 'divider',
            }}
        >
            <MetricItem label="Net PnL" value={netPnl.toFixed(0)} positive={netPnl >= 0} />
            <MetricItem
                label="Return"
                value={`${(metrics.total_return * 100).toFixed(3)}%`}
                positive={metrics.total_return >= 0}
            />
            <MetricItem label="Sharpe" value={metrics.sharpe.toFixed(2)} />
            <MetricItem label="Max DD" value={`${(metrics.max_drawdown * 100).toFixed(2)}%`} />
            <MetricItem label="Win rate" value={`${(metrics.win_rate * 100).toFixed(1)}%`} />
            <MetricItem label="Trades" value={String(metrics.num_trades)} />
        </Box>
    );
}
